export const getDefault = () => {
  const schema = {
    name: 'Timely',
    background: '#4D93FF',
    textColor: '#000',
    title: 'Timely',
    identifier: '2x770b0s'
  }
  return schema
}
